import { useState } from "react";
import { setSelectId, setSelectTypeForm } from "../../../../redux/slices/simulation/simulation";
import { requetsDeleteProviderSimulation, requetsProviderSimulation } from "../../../../redux/slices/simulation/simulationAction";
import { columnsProviderSimulation } from "../../../../types/columnsTables/columnProviderSimulation";
import { typeForm } from "../../../../types/forms";
import { Form } from "antd";

export const useColumnsProviderSimulation = (dispatch, updateProject) => {
    const [formProvider] = Form.useForm();
    const [formProviderExplandle] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");
    const [editingExpandle, setEditingExpandle] = useState("");

    const onEditForm = async (type = 0) => {
        try {
            setEditingKey("");
            setEditingExpandle("");
            let structureJson = {};
            const rowProvider = await formProvider.validateFields();
            structureJson = {
                name: rowProvider.name,
                price: rowProvider.price,
                currency: rowProvider.currency,
                link: rowProvider.link,
                status: rowProvider.status,
                area: rowProvider.area,
            };
            dispatch(requetsProviderSimulation(structureJson, updateProject));
        } catch (error) {
            console.log("error");
        }
    };

    const activeEdit = (id, type = 0) => {
        dispatch(setSelectTypeForm(typeForm.edit));
        dispatch(setSelectId(id));
        if (type === 0) {
            setEditingExpandle("-");
            setEditingKey(id);
        }
        if (type === 1) {
            setEditingExpandle(id);
            setEditingKey("-");
        }
    };

    const editActive = (record) => {
        formProvider.setFieldsValue({
            name: record.name,
            price: record.price,
            currency: record.currency,
            link: record.link,
            status: record.status,
            area: record.area,
        });
        activeEdit(record.key, 0);
    };

    const editExpandleActive = (record) => {
        formProviderExplandle.setFieldsValue({
            correctedHours: record.correctedHours,
            externalInmersysHours: record.externalInmersysHours,
            budget: record.budget,
            providerHours: record.providerHours,
        });
        activeEdit(record.id, 1);
    };

    //* column

    const { columns, props } = columnsProviderSimulation(
        {
            editAction: editActive,
            deleteAction: (form) => {
                dispatch(requetsDeleteProviderSimulation(form.key, updateProject));
            },
            isEditing: (record) => record.key === editingKey,
            cancelSave: () => {
                setEditingKey("");
            },
            editSave: onEditForm,
            cancelExpandle: () => {
                setEditingExpandle("");
                setEditingKey("");
            },
            editExpandleActive,
            isEditingExpladle: (record) => record.id === editingExpandle,
        },
        {
            editingKey: editingKey,
            editingExpandle: editingExpandle,
            formProviderExplandle: formProviderExplandle,
        }
    );
    return { columns, props, formProvider: formProvider };
};
